export default function ClearSelect({ formik }) {
  formik.setFieldValue('cars', []);
}
